export default __webpack_public_path__ + "static/media/teslaLogo.b23804fa.png";